import React from "react";
import { useTranslation } from "react-i18next";
import { Label } from "@/shared/ui/label";
import { Input } from "@/shared/ui/input"
import { formatTimestamp } from "@/shared/lib/appHelpers"
import { useCurrentTool } from "@/shared/hooks/useCurrentTool"

function ReportFields({ report, editClicked, dynamicFields, handleInputChange }) {
  const { t } = useTranslation();
  const { currentToolFields } = useCurrentTool();
  
  return (
    <div className={`grid ${editClicked ? 'grid-cols-3 gap-3' : 'grid-cols-2 gap-3 sm:grid-cols-4'}`}>
      {currentToolFields?.map((field) => (
        editClicked ?
          <div key={field.name} className="flex flex-col gap-1.5">
            <Label>{t(`fields.${field.name}`)}</Label>
            <Input
              name={field.name}
              value={dynamicFields[field.name] || ''}
              type='text'
              onChange={(e) => handleInputChange({ key: field.name, value: e.target.value })}
            />
          </div>
          :
          <div key={field.name}>
            <p className="text-sm text-[#71717a] font-medium">
              {t(`fields.${field.name}`)}
            </p>
            <p className="text-sm text-black font-medium">
              {report.fields?.[field.name]}
            </p>
          </div>
      ))}
      {!editClicked &&
        <div>
          <p className="text-[14px] text-[#71717a] font-medium">
            {t("common.date")}
          </p>
          <p className="text-[14px] text-black font-medium">
            {formatTimestamp(report.created_at, 'd.m.y')}
          </p>
        </div>
      }
    </div>
  );
}

export default ReportFields;
